export class BareProduct {
    code: number= 0;
    name: string= "";
    packaging: string= "";
    category: string="";
}